module.exports = __webpack_public_path__ + "img/p5-p1-chuan.fa6d5f4c.png";